// src/screens/components/Header.jsx
import React from 'react';
import { useEstructura } from '../../context/EstructuraContext';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const {
    campos = [],
    campoSeleccionado,
    setCampoSeleccionado,
    userName = 'Usuario',
    handleLogout
  } = useEstructura();
  const navigate = useNavigate();

  const onCampoChange = (e) => {
    const id = parseInt(e.target.value, 10);
    const nuevo = campos.find(c => c.campoId === id) || null;
    setCampoSeleccionado(nuevo);
    // Redirige siempre al home para ver equipos del campo seleccionado
    navigate('/home');
  };

  return (
    <header className="bg-white shadow px-6 py-3 flex items-center justify-between">
      {/* Logo y título dinámico */}
      <div className="flex items-center gap-2">
        <span style={{ fontSize: '1.75rem' }}>🌿</span>
        <h1 className="text-2xl font-bold text-gray-800 truncate">
          {campoSeleccionado?.campoNombre || 'Sistema de Riego'}
        </h1>
      </div>

      {/* Selector de campo, avatar y logout */}
      <div className="flex items-center gap-4">
        <select
          value={campoSeleccionado?.campoId ?? ''}
          onChange={onCampoChange}
          className="border border-gray-300 rounded px-3 py-2 text-sm bg-white"
        >
          {campos.map(c => (
            <option key={c.campoId} value={c.campoId}>
              {c.campoNombre}
            </option>
          ))}
        </select>

        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-semibold uppercase">
            {userName.charAt(0)}
          </div>
          <span className="font-medium text-gray-700">{userName}</span>
        </div>

        <button
          onClick={handleLogout}
          className="bg-gradient-to-r from-blue-400 to-cyan-400 text-white px-4 py-1.5 rounded-full text-sm font-semibold shadow hover:from-blue-500 hover:to-cyan-500 transition"
        >
          Cerrar sesión
        </button>
      </div>
    </header>
  );
}
